import React, { useCallback, useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { getRequest, postRequest } from '../../helpers/apiHandler';
import './_userRate.scss';

const UpdateUserRateModal = ({ show, handleClose, setAlertState, getCreditData, userRateData }) => {
  const { access_token } = useSelector((state) => state.auth.user);
  const [selectedUser, setSelectedUser] = useState({});
  const [selectedIso2, setSelectedIso2] = useState({});
  const [rate, setRate] = useState(0.0);
  const [loadingData, setLoadingData] = useState(false);
  const [users, setUsers] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  const fetchData = useCallback(() => {
    setLoadingData(true);
    const data = { headers: { Authorization: access_token.token } };
    getRequest(`/admin/user-management`, data, (res) => {
      if (res.success) {
        const result = res.data;
        setUsers(result);
      } else {
        setAlertState({
          message: 'There was an issue while fetching user data',
          show: true,
          variant: 'danger',
        });
      }
      setLoadingData(false);
    });
  }, []);

  const resetValues = () => {
    setUsers([]);
    setRate(0.0);
    setSelectedUser([]);
    setSelectedIso2([]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      rate_id: userRateData.id,
      rate: rate,
      iso2: selectedIso2.value,
    };

    postRequest('/admin/user-rates-update', data, access_token.token, (res) => {
      if (res.success) {
        setAlertState({
          show: true,
          variant: 'success',
          message: 'Success updating data.',
        });
      } else {
        setAlertState({
          show: true,
          variant: 'danger',
          message: res.message,
        });
      }
      getCreditData();
    });
    resetValues();
    handleClose();
  };

  const fetchCurrencies = useCallback(() => {
    const data = { headers: { Authorization: access_token.token } };
    getRequest(`/admin/user-rates-currencies`, data, (res) => {
      if (res.success) {
        const currencyOptions = res.data.map((currency) => ({
          value: currency.country_code,
          label: currency.country_name,
        }));
        setCurrencies(currencyOptions);
      } else {
        setAlertState({
          message: 'There was an issue while fetching currencies',
          show: true,
          variant: 'danger',
        });
      }
    });
  }, [access_token.token, setAlertState]);

  useEffect(() => {
    fetchCurrencies();
    if (show) {
      fetchData();
      if (userRateData) {
        setSelectedUser({
          label: `${userRateData.name} (${userRateData.email})`,
          value: userRateData.email,
        });

        currencies.forEach((currency) => {
          if (currency.value === userRateData.iso2) {
            setSelectedIso2(currency);
          }
        });
        const costNumber = parseFloat(userRateData.cost.split(' ')[1]);
        setRate(costNumber);
      }
    }
  }, [show, fetchCurrencies]);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Update User Rate</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>{selectedUser.value}</h4>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="isoSelect2">
            <Form.Label>Select Country</Form.Label>
            <Select
              value={selectedIso2}
              multi={false}
              onChange={(e) => {
                setSelectedIso2(e);
              }}
              options={currencies}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Rate</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter rate"
              step="0.001"
              min="0.0"
              value={rate}
              onChange={(e) => setRate(e.target.value)}
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Update
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateUserRateModal;
